import React from 'react';
import { useRouter } from 'next/navigation';
import { useSelector } from 'react-redux';

const imgComponent1 = "/images/assets/9b233eb3f3d133c8c9ca388526cfa8718ad4e843.png";
const imgMacbookAirMockup21 = "/images/assets/3325873493645da52753ca4efb6d1e68e465bdba.png";

function Frame55() {
  return (
    <div className="flex flex-col items-end w-full">
      <p className="font-['Roboto:Medium',sans-serif] font-medium leading-tight text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-[44px] 2xl:text-[56px] xl:leading-[48px] 2xl:leading-[56px] text-center md:text-right text-white w-full" style={{ fontVariationSettings: "'wdth' 100" }}>
        Hire Skilled Freelancers for Any Need — Personal or Professional.
      </p>
    </div>
  );
}

function Frame60() {
  return (
    <div className="flex flex-col gap-4 md:gap-6 lg:gap-8 items-start w-full">
      <Frame55 />
      <p className="font-['Roboto:SemiBold',sans-serif] font-semibold leading-relaxed text-sm md:text-base lg:text-lg text-center md:text-right text-white w-full" style={{ fontVariationSettings: "'wdth' 100" }}>
        From business projects to personal services, HyreLancer helps you find the right expert quickly and easily.
      </p>
    </div>
  );
}

function Frame56({ onGetStarted }) {
  return (
    <div className="flex flex-col gap-3 md:gap-8 lg:gap-10 xl:gap-12 items-center md:items-end px-4 md:px-6 lg:px-8 xl:px-0 pt-16 sm:pt-20 md:py-12 lg:py-16 xl:py-[106px] pb-0 md:pb-12 w-full lg:max-w-[650px] xl:max-w-[739px] 2xl:max-w-[839px] xl:self-center z-10 relative">
      <Frame60 />
      <button 
        onClick={onGetStarted}
        className="bg-white flex items-center justify-center px-6 py-3 md:px-7 lg:px-8 rounded-full w-full sm:w-auto min-w-[180px] md:min-w-[220px] lg:min-w-[245px] h-11 md:h-12 lg:h-[48px] hover:bg-opacity-90 transition-all"
      >
        <p className="font-['Roboto:SemiBold',sans-serif] font-semibold leading-6 text-[#3a599c] text-sm md:text-base whitespace-nowrap" style={{ fontVariationSettings: "'wdth' 100" }}>
          Get Started
        </p>
      </button>
    </div>
  );
}

function Frame57({ onGetStarted }) {
  return (
    <div className="flex justify-center md:justify-end 2xl:items-center w-full h-full px-4 md:px-6 lg:px-12 xl:px-32">
      <Frame56 onGetStarted={onGetStarted} />
    </div>
  );
}

function ComponentHero({ onGetStarted }) {
  return (
    <div className="relative w-full h-full min-h-[550px] sm:min-h-[600px] md:min-h-0 rounded-2xl md:rounded-3xl lg:rounded-[32px]" data-name="Component 1">
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none rounded-2xl md:rounded-3xl lg:rounded-[32px] overflow-hidden z-[1]">
        <div className="absolute bg-[#3a599c] inset-0 rounded-2xl md:rounded-3xl lg:rounded-[32px]" />
        <img alt="" className="absolute w-full h-full object-cover opacity-[0.04] rounded-2xl md:rounded-3xl lg:rounded-[32px]" src={imgComponent1} />
      </div>
      <div className="relative z-10 h-full">
        <Frame57 onGetStarted={onGetStarted} />
      </div>
    </div>
  );
}

export default function HeroSection() {
  const router = useRouter();
  const { user, token, isAuthenticated } = useSelector(state => state.auth);

  const handleGetStarted = () => {
    if (!isAuthenticated && !token && !user) {
      router.push('/login');
      return;
    }

    const userType = user?.user_type;
    if (userType === "Customer" || userType === "customer") {
      router.push('/customer-dashboard/job-post');
    } else if (userType === "Freelancer" || userType === "freelancer") {
      router.push('/freelancer-dashboard/jobs');
    } else {
      router.push('/login');
    }
  };

  return (
    <div className="relative w-full h-auto md:h-[500px] lg:h-[600px] xl:h-[650px] 2xl:h-[781px] max-w-[1888px] mx-auto overflow-visible">
       {/* Desktop Layout - Side by Side */}
       <div className="hidden md:block relative w-full h-full overflow-visible">
         <ComponentHero onGetStarted={handleGetStarted} />
         {/* Laptop Image - Responsive sizing on all screens */}
         <div className="absolute h-[450px] md:h-[400px] lg:h-[650px] xl:h-[730px] 2xl:h-[1029px] -left-[250px] md:-left-[100px] lg:-left-[280px] xl:-left-[300px] 2xl:left-[-400px] top-[-40px] md:top-[150px] lg:top-[0px] xl:top-[-20px] 2xl:top-[-150px] w-[60%] md:w-[65%] lg:w-[80%] xl:w-[900px] 2xl:w-[1296px] pointer-events-none z-[5]" data-name="Macbook_Air_Mockup_2 1">
           <div className="relative w-full h-full">
             <img alt="" className="absolute h-full w-auto max-w-none object-contain" src={imgMacbookAirMockup21} />
           </div>
         </div>
       </div>

      {/* Mobile Layout - Laptop inside banner */}
      <div className="md:hidden relative w-full">
        <ComponentHero onGetStarted={handleGetStarted} />
        
        {/* Laptop Mockup Inside Banner - Below Text */}
        <div className="absolute left-[40%] -translate-x-1/2 w-[90%] max-w-[500px] h-[250px] sm:h-[350px] z-[8] -bottom-8 sm:-bottom-12">
          <div className="relative w-full h-full flex items-center justify-center">
            <img 
              alt="" 
              className="w-full h-auto object-contain" 
              src={imgMacbookAirMockup21} 
            />
          </div>
        </div>
      </div>
    </div>
  );
}